import { Outlet } from 'react-router';

const CreatePurchaseOrderPage = () => {
  return <Outlet />;
};

export default CreatePurchaseOrderPage;
